import { __awaiter } from "tslib";
import Vue from 'vue';
import _ from 'lodash';
import ahead from '@/components/pages/whitelists/main/components/ahead/index.vue';
import whitelistItem from '@/components/pages/whitelists/main/components/item/index.vue';
import whiteListAside from '@/components/pages/whitelists/main/components/aside/index.vue';
import { ActivePopupTypes } from '@/store/modules/popup/types';
import { AsideModes } from '@/components/pages/whitelists/main/interfaces/index';
import { mapGetters } from 'vuex';
import stepByStepValidate from '@/services/_helpers/stepByStepValidate';
import { StepByStepGlossary } from '@/constants/services';
import { YubikeyAuthMixin } from '@/mixins/YubikeyAuthMixin';
export default Vue.extend({
    name: 'whitelistsBody',
    mixins: [YubikeyAuthMixin],
    data: () => ({
        secretCodeExist: false,
        secretCodeFieldValid: false,
        addressesShows: false,
        asideMode: AsideModes.default,
        items: [],
        loadError: false,
        isRetry: false,
        fromResetSecret: false,
        isPasswordReset: false,
        availableNetworks: [],
        searchPhrase: ''
    }),
    computed: Object.assign(Object.assign({}, mapGetters('user', ['getUserData'])), { computedList() {
            return this.items.filter((item) => {
                if (!this.searchPhrase.length)
                    return true;
                return item.name.toLowerCase().includes(this.searchPhrase.toLowerCase());
            });
        },
        letMultiEditNetworks() {
            return this.items.length > 0 && this.items.some((item) => !item.network);
        },
        selectedItems() {
            const vm = this;
            return vm.items.filter((item) => item.selected);
        },
        itemsCountWithShowsAddresses() {
            const vm = this;
            return vm.items.filter((item) => item.addressVisible).length;
        } }),
    watch: {
        letMultiEditNetworks(v) {
            if (v && !this.$cookies.get('haveUnresolvedNetworksInWhitelists')) {
                const vm = this;
                const host = window.location.hostname.split('.').reverse()[1] + '.' + location.hostname.split('.').reverse()[0];
                this.$cookies.set('haveUnresolvedNetworksInWhitelists', true, {
                    expires: 365,
                    domain: '.' + host
                });
                vm.$store.dispatch('popupModule/openPopup', {
                    type: ActivePopupTypes.action,
                    letDefaultClose: true,
                    title: 'Отсутствие сетей в кошельках',
                    content: 'У некоторых ваших кошельков отсутствует параметр сети. <br /><br />Для совершения выводов сеть должна быть установлена заранее.',
                    actions: [
                        {
                            title: vm.$t('whitelistsPage.chooseNetwork'),
                            isAccent: true,
                            callback() {
                                vm.$router.push({ name: 'whitelistsResolveNetworksPage' });
                            }
                        },
                        {
                            title: vm.$t('whitelistsPage.popups.actions.later'),
                            isAccent: false,
                            callback() {
                                vm.$store.commit('popupModule/setClosed');
                            }
                        }
                    ]
                });
            }
        },
        itemsCountWithShowsAddresses(v) {
            const vm = this;
            if (v === vm.items.length)
                vm.addressesShows = true;
            if (v === 0)
                vm.addressesShows = false;
        },
        searchPhrase() {
            this.items.forEach((item) => {
                item.selected = false;
            });
        }
    },
    methods: {
        handleClickResolveNetworks() {
            if (!this.selectedItems.length) {
                this.$router.push({ name: 'whitelistsResolveNetworksPage' });
            }
            else {
                this.$router.push({
                    name: 'whitelistsResolveNetworksPage',
                    query: {
                        id: this.selectedItems[0].id,
                        name: this.selectedItems[0].name
                    }
                });
            }
        },
        returnToPreviousRoute() {
            const vm = this;
            if (window.history.state === null) {
                vm.$router.replace({ name: 'mainPage' });
            }
            else {
                vm.$router.go(-1);
            }
        },
        deselectAll() {
            const vm = this;
            vm.asideMode = 'default';
            vm.items.forEach((item) => { item.selected = false; });
        },
        handleClickBeginReset() {
            const vm = this;
            vm.$store.dispatch('popupModule/openPopup', {
                type: 'confirmPopup',
                letDefaultClose: true,
                title: vm.$t('whitelistsPage.popups.titles.repairSecretCode'),
                content: vm.$t('whitelistsPage.popups.content.allAddressWilRemove'),
                actions: [
                    {
                        title: vm.$t('whitelistsPage.popups.actions.continue'),
                        isAccent: true,
                        callback() {
                            vm.$store.dispatch('popupModule/openPopup', {
                                type: ActivePopupTypes.action,
                                letDefaultClose: true,
                                title: vm.$t('whitelistsPage.popups.titles.repairSecretCode'),
                                content: vm.$t('whitelistsPage.popups.content.enterNewCodeBelow'),
                                slot: {
                                    name: 'setUpNewSecretPopupChunk',
                                    data: {},
                                    on: {
                                        onSubmit(newSecret) {
                                            return __awaiter(this, void 0, void 0, function* () {
                                                vm.$store.commit('popupModule/setSlotData', { isLoading: true, responseErrors: [] });
                                                const confirmationType = vm.getUserData.confirmation;
                                                const smsVerify = confirmationType === 'sms';
                                                if (confirmationType === 'yubikey') {
                                                    const yubikeyResetWalletSecret = () => {
                                                        vm.YubikeyAuth(StepByStepGlossary.resetWalletSecret, StepByStepGlossary.resetWalletSecret, (authResponse, sessionId) => __awaiter(this, void 0, void 0, function* () {
                                                            var _a;
                                                            if (!authResponse.success) {
                                                                vm.$store.commit('popupModule/setClosed');
                                                                vm.$store.dispatch('alertsBus/openAlert', {
                                                                    title: vm.$t('whitelistsPage.alerts.titles.error'),
                                                                    type: 'error',
                                                                    autoDelete: true,
                                                                    content: (_a = authResponse.errors.join('\n')) !== null && _a !== void 0 ? _a : vm.$t('whitelistsPage.alerts.content.failedToExecOperation')
                                                                });
                                                            }
                                                            const response = yield vm.services.mainService.resetWhitelistSecret({ sessionId, payload: { walletSecret: newSecret } });
                                                            vm.$store.commit('popupModule/setClosed');
                                                            if (!response.success) {
                                                                vm.$store.dispatch('alertsBus/openAlert', {
                                                                    title: vm.$t('whitelistsPage.alerts.titles.error'),
                                                                    type: 'error',
                                                                    autoDelete: true,
                                                                    content: vm.$t('whitelistsPage.alerts.content.failedToChangeSecretCode')
                                                                });
                                                                vm.isPasswordReset = false;
                                                                return;
                                                            }
                                                            vm.isPasswordReset = true;
                                                            vm.init();
                                                            vm.$store.dispatch('alertsBus/openAlert', {
                                                                title: vm.$t('whitelistsPage.alerts.titles.success'),
                                                                type: 'success',
                                                                autoDelete: true,
                                                                content: vm.$t('whitelistsPage.alerts.content.secretCodeChanged')
                                                            });
                                                        }), null, yubikeyResetWalletSecret);
                                                    };
                                                    yubikeyResetWalletSecret();
                                                    return;
                                                }
                                                const sessionResponse = yield stepByStepValidate({
                                                    name: StepByStepGlossary.resetWalletSecret,
                                                    endpointName: StepByStepGlossary.confirmSession,
                                                    data: {
                                                        sessionId: StepByStepGlossary.resetWalletSecret,
                                                        walletSecret: newSecret
                                                    },
                                                    steps: 3
                                                });
                                                const codes = sessionResponse.data.confirmations;
                                                vm.$store.commit('popupModule/setSlotData', { isLoading: false });
                                                if (sessionResponse.success) {
                                                    vm.$store.dispatch('popupModule/openPopup', {
                                                        type: ActivePopupTypes.action,
                                                        letDefaultClose: true,
                                                        title: vm.$t('whitelistsPage.popups.titles.repairSecretCode'),
                                                        content: vm.$t('whitelistsPage.popups.content.verify'),
                                                        slot: {
                                                            name: smsVerify ? 'emailSMSConfirmPopupChunk' : 'emailGAConfirmPopupChunk',
                                                            data: {
                                                                name: StepByStepGlossary.resetWalletSecret,
                                                                endpointName: StepByStepGlossary.validateSession,
                                                                sessionId: sessionResponse.data.session_id,
                                                                codes,
                                                                isLoading: false
                                                            },
                                                            on: {
                                                                // eslint-disable-next-line
                                                                onSuccess() {
                                                                    return __awaiter(this, void 0, void 0, function* () {
                                                                        vm.$store.commit('popupModule/setSlotData', { isLoading: true });
                                                                        const response = yield vm.services.mainService.resetWhitelistSecret({ sessionId: sessionResponse.data.session_id, payload: { walletSecret: newSecret } });
                                                                        vm.$store.commit('popupModule/setSlotData', { isLoading: false });
                                                                        vm.$store.commit('popupModule/setClosed');
                                                                        if (response.success) {
                                                                            vm.isPasswordReset = true;
                                                                            vm.init();
                                                                            vm.$store.dispatch('alertsBus/openAlert', {
                                                                                title: vm.$t('whitelistsPage.alerts.titles.success'),
                                                                                type: 'success',
                                                                                autoDelete: true,
                                                                                content: vm.$t('whitelistsPage.alerts.content.secretCodeChanged')
                                                                            });
                                                                            return;
                                                                        }
                                                                        vm.$store.dispatch('alertsBus/openAlert', {
                                                                            title: vm.$t('whitelistsPage.alerts.titles.error'),
                                                                            type: 'error',
                                                                            autoDelete: true,
                                                                            content: response.data.errors
                                                                        });
                                                                    });
                                                                },
                                                                onCancel() {
                                                                    vm.$store.commit('popupModule/setClosed');
                                                                    vm.$store.dispatch('alertsBus/openAlert', {
                                                                        title: vm.$t('whitelistsPage.alerts.titles.error'),
                                                                        type: 'error',
                                                                        autoDelete: true,
                                                                        content: vm.$t('whitelistsPage.alerts.content.failedToChangeSecretCode')
                                                                    });
                                                                    vm.isPasswordReset = false;
                                                                }
                                                            }
                                                        }
                                                    });
                                                }
                                                else {
                                                    vm.$store.commit('popupModule/setSlotData', { responseErrors: sessionResponse.errors });
                                                }
                                            });
                                        }
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: 'Отмена',
                        isAccent: false,
                        callback() {
                            vm.$router.push({ name: 'whitelists' });
                            vm.$store.commit('popupModule/setClosed');
                        }
                    }
                ]
            });
        },
        handleAheadAddAddressEvent() {
            const vm = this;
            if (vm.selectedItems.length)
                vm.selectedItems[0].selected = false;
            vm.asideMode = AsideModes.create;
        },
        handleToggleShowAllAddresses(secret) {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                if (vm.addressesShows) {
                    vm.addressesShows = false;
                    vm.items.forEach((item) => {
                        item.addressVisible = false;
                        item.address = null;
                    });
                }
                else {
                    const response = yield vm.services.mainService.getWhitelistWalletsWithAddresses({ walletSecret: secret });
                    if (response.success) {
                        vm.items = vm.items = response.data.wallets.map((item) => {
                            item.address = item.address ? item.address : '';
                            item.selected = false;
                            item.addressVisible = Boolean(item.address);
                            return item;
                        });
                    }
                    else {
                        vm.$store.dispatch('alertsBus/openAlert', {
                            title: vm.$t('whitelistsPage.alerts.titles.error'),
                            type: 'error',
                            autoDelete: true,
                            content: vm.$t('whitelistsPage.alerts.content.failedToLoadAddress')
                        });
                    }
                }
            });
        },
        handleAddAddress(payload) {
            const vm = this;
            vm.items.push({
                id: vm.items.length ? vm.items.last.id + 1 : 0,
                name: payload.name,
                address: payload.address,
                selected: false,
                addressVisible: false
            });
        },
        handleDeleteAddress(secret) {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                const response = yield vm.services.mainService.deleteWhitelistWallet({
                    walletSecret: secret,
                    ids: [vm.selectedItems[0].id]
                });
                if (response.success) {
                    vm.items.splice(_.findIndex(vm.items, (item) => item.id === vm.selectedItems[0].id), 1);
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('whitelistsPage.alerts.titles.success'),
                        type: 'success',
                        autoDelete: true,
                        content: vm.$t('whitelistsPage.alerts.content.addressDeleted')
                    });
                }
                else {
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('whitelistsPage.alerts.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        content: response.data.errors.join('\n')
                    });
                }
            });
        },
        handleToggleAddressVisibility(payload) {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                const item = vm.items.find((item) => item.id === payload.id);
                if (item.addressVisible) {
                    item.addressVisible = false;
                }
                else {
                    const response = yield vm.services.mainService.getWhitelistWalletsWithAddresses({
                        walletSecret: payload.secret
                    }, payload.id);
                    if (response.success) {
                        item.addressVisible = true;
                        item.address = response.data.wallets[0].address;
                    }
                    else {
                        vm.$store.dispatch('alertsBus/openAlert', {
                            title: vm.$t('whitelistsPage.alerts.titles.error'),
                            type: 'error',
                            autoDelete: true,
                            content: vm.$t('whitelistsPage.alerts.content.failedToShowAddress', { name: item.name })
                        });
                    }
                }
            });
        },
        handleChangeName(payload) {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                const response = yield vm.services.mainService.whitelistChangeName({
                    name: payload.newName,
                    id: payload.id
                });
                if (response.success) {
                    vm.items.forEach((item) => {
                        if (item.id === payload.id)
                            item.name = payload.newName;
                    });
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('whitelistsPage.alerts.titles.success'),
                        type: 'success',
                        autoDelete: true,
                        content: vm.$t('whitelistsPage.alerts.content.nameSuccessChanged')
                    });
                }
                else {
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('whitelistsPage.alerts.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        content: vm.$t('whitelistsPage.alerts.content.failedToChangeName')
                    });
                }
            });
        },
        handleAddressClick(item) {
            const vm = this;
            vm.items.forEach((addressWallet) => {
                if (addressWallet.id !== item.id) {
                    addressWallet.selected = false;
                }
                else {
                    addressWallet.selected = !addressWallet.selected;
                }
            });
        },
        init() {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                vm.loadError = false;
                vm.isRetry = true;
                let secretExists = false;
                const checkSecretExistsResponse = yield vm.services.mainService.checkWhitelistSecret(null);
                if (checkSecretExistsResponse.success) {
                    secretExists = checkSecretExistsResponse.data.walletSecret;
                    vm.secretCodeExist = checkSecretExistsResponse.data.walletSecret;
                    if (!secretExists) {
                        vm.$store.dispatch('popupModule/openPopup', {
                            type: ActivePopupTypes.action,
                            letDefaultClose: false,
                            title: vm.$t('whitelistsPage.popups.titles.createSecretCode'),
                            content: vm.$t('whitelistsPage.popups.content.comeUpSecretCode'),
                            slot: {
                                name: 'createSecretPopupChunk',
                                data: {},
                                on: {
                                    onSubmit(walletSecret) {
                                        return __awaiter(this, void 0, void 0, function* () {
                                            const confirmationType = vm.getUserData.confirmation;
                                            if (confirmationType === 'yubikey') {
                                                const yubikeyCreateSecret = () => {
                                                    vm.YubikeyAuth(StepByStepGlossary.createWalletSecret, StepByStepGlossary.createWalletSecret, (authResponse, sessionId) => __awaiter(this, void 0, void 0, function* () {
                                                        if (!authResponse.success)
                                                            return vm.returnToPreviousRoute();
                                                        const createSecretResponse = yield vm.services.mainService.changeWhitelistSecret({ sessionId, payload: { walletSecret } });
                                                        if (createSecretResponse.success && !createSecretResponse.data) {
                                                            vm.init();
                                                            vm.$store.dispatch('alertsBus/openAlert', {
                                                                title: vm.$t('whitelistsPage.alerts.titles.success'),
                                                                type: 'success',
                                                                autoDelete: true,
                                                                content: vm.$t('whitelistsPage.alerts.content.secretCreated')
                                                            });
                                                            vm.$store.commit('popupModule/setClosed');
                                                        }
                                                        else {
                                                            vm.$store.dispatch('alertsBus/openAlert', {
                                                                title: vm.$t('whitelistsPage.alerts.titles.error'),
                                                                type: 'error',
                                                                autoDelete: true,
                                                                content: vm.$t('whitelistsPage.alerts.content.failedCreateSecretCode')
                                                            });
                                                        }
                                                        vm.$store.commit('popupModule/setSlotData', { isLoading: false });
                                                    }), null, yubikeyCreateSecret);
                                                };
                                                yubikeyCreateSecret();
                                                return;
                                            }
                                            const response = yield vm.services.mainService.confirmSession({ sessionId: StepByStepGlossary.createWalletSecret });
                                            if (!response.success) {
                                                vm.$store.commit('popupModule/setClosed');
                                                vm.$store.dispatch('alertsBus/openAlert', {
                                                    title: vm.$t('whitelistsPage.alerts.titles.error'),
                                                    type: 'error',
                                                    autoDelete: true,
                                                    content: vm.$t('whitelistsPage.alerts.content.failedExecOperation')
                                                });
                                                return;
                                            }
                                            const sessionId = response.data.session_id;
                                            const confirmations = response.data.confirmations;
                                            const smsVerify = confirmationType === 'sms';
                                            vm.$store.dispatch('popupModule/openPopup', {
                                                type: ActivePopupTypes.action,
                                                letDefaultClose: false,
                                                title: vm.$t('whitelistsPage.popups.titles.confirmOperation'),
                                                content: vm.$t('whitelistsPage.popups.content.operationRequiredConfirmation', { type: smsVerify ? vm.$t('whitelistsPage.popups.content.viaSMS') : 'Google Authenticator' }),
                                                slot: {
                                                    name: `commonConfirm${confirmationType.toUpperCase()}PopupChunk`,
                                                    data: {
                                                        codes: confirmations,
                                                        disableClose: true,
                                                        isLoading: false,
                                                        responseErrors: []
                                                    },
                                                    on: {
                                                        onSubmit(payload) {
                                                            return __awaiter(this, void 0, void 0, function* () {
                                                                vm.$store.commit('popupModule/setSlotData', { isLoading: true });
                                                                const validateSessionResponse = yield vm.services.mainService.validateSession({ payload: { [confirmationType]: payload[`code_${confirmationType}`] }, sessionId });
                                                                if (!validateSessionResponse.success) {
                                                                    vm.$store.commit('popupModule/setSlotData', { responseErrors: validateSessionResponse.data.errors, isLoading: false });
                                                                    return;
                                                                }
                                                                const createSecretResponse = yield vm.services.mainService.changeWhitelistSecret({ sessionId, payload: { code: smsVerify ? payload.code_sms : payload.code_ga, walletSecret } });
                                                                if (createSecretResponse.success && !createSecretResponse.data) {
                                                                    vm.init();
                                                                    vm.$store.dispatch('alertsBus/openAlert', {
                                                                        title: vm.$t('whitelistsPage.alerts.titles.success'),
                                                                        type: 'success',
                                                                        autoDelete: true,
                                                                        content: vm.$t('whitelistsPage.alerts.content.secretCreated')
                                                                    });
                                                                    vm.$store.commit('popupModule/setClosed');
                                                                }
                                                                else {
                                                                    vm.$store.dispatch('alertsBus/openAlert', {
                                                                        title: vm.$t('whitelistsPage.alerts.titles.error'),
                                                                        type: 'error',
                                                                        autoDelete: true,
                                                                        content: vm.$t('whitelistsPage.alerts.content.failedExecOperation')
                                                                    });
                                                                }
                                                                vm.$store.commit('popupModule/setSlotData', { isLoading: false });
                                                            });
                                                        },
                                                        onCancel() {
                                                            vm.returnToPreviousRoute();
                                                        }
                                                    }
                                                }
                                            });
                                        });
                                    },
                                    onCancel() {
                                        vm.returnToPreviousRoute();
                                    }
                                }
                            }
                        });
                    }
                    else {
                        const response = yield vm.services.mainService.getWhitelistWallets(null);
                        if (response.success) {
                            vm.loadError = false;
                            vm.isRetry = false;
                            vm.items = response.data.wallets.map((item) => {
                                item.address = item.address ? item.address : '';
                                item.selected = false;
                                item.addressVisible = Boolean(item.address);
                                return item;
                            });
                            vm.availableNetworks = response.data.networks;
                        }
                        else {
                            vm.loadError = true;
                            vm.isRetry = false;
                        }
                    }
                }
                else {
                    vm.loadError = true;
                    vm.isRetry = false;
                }
                vm.loadError = false;
                vm.isRetry = false;
                if (this.$route.query.mode && this.$route.query.mode in AsideModes) {
                    this.asideMode = this.$route.query.mode;
                }
            });
        }
    },
    mounted() {
        const vm = this;
        const fromResetSecret = this.$route.query.reset === 'secret';
        fromResetSecret && !vm.isPasswordReset && vm.handleClickBeginReset();
        vm.init();
    },
    components: {
        ahead,
        whitelistItem,
        whiteListAside
    }
});
